import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import MessageCreate from './MessageCreate/MessageCreate';

const Messages = ({ match }) => {
    return (
        <div className="Messages">
            <ContainerWrapper container="messages">
                <Route exact path={ match.path } component={MessageCreate} />
            </ContainerWrapper>
        </div>
    );
}

export default Messages;
